import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format.js';
import { IconArrowRight } from '$partials/icon/index.js';
import { isLocalURL } from '$utilities/browser';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TextColumns}
 */
const TextColumns = ({
    cells,
    ctaLabel,
    ctaLink,
    heading,
    label,
    modulePaddingClasses = ''
}) => {
    const href = formatLinkBlockToUrl(ctaLink);
    const isExternal = href && !isLocalURL(href);

    return (
        <section className='module-text-columns'>
            <div className={`layout-container bg-neutral-00 ${modulePaddingClasses}`}>
                <div className='layout-grid flex-col sm:flex-row sm:flex-wrap gap-y-10 sm:gap-y-0'>
                    <div className='sm:w-4/12 lg:w-3/12 layout-grid-col'>
                        {label && (
                            <h2 className='type-style-heading'>{label}</h2>
                        )}
                    </div>

                    <div className='flex flex-col gap-y-16 sm:gap-y-32 sm:w-8/12'>
                        {heading && (
                            <div className='w-full layout-grid-col'>
                                {label && (
                                    <p className='type-style-heading sm:w-5/8'>{heading}</p>
                                )}

                                {!label && (
                                    <h2 className='type-style-heading sm:w-5/8'>{heading}</h2>
                                )}
                            </div>
                        )}

                        {cells?.length > 0 && (
                            <div className='w-full flex flex-col sm:flex-row sm:flex-wrap gap-y-12 sm:gap-y-24'>
                                {cells.map((cell) => (
                                    <div
                                        className='w-full sm:w-3/8 layout-grid-col'
                                        key={cell.id}>
                                        {cell.title && (
                                            <h3 className='type-style-body-bold'>{cell.title}</h3>
                                        )}

                                        {cell.text && (
                                            <div
                                                className='rich-text type-style-body'
                                                dangerouslySetInnerHTML={{ __html: cell.text }} />
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        {(ctaLabel && href) && (
                            <p className='layout-grid-col'>
                                <a
                                    className='button type-style-body cursor-pointer'
                                    href={href}
                                    rel={isExternal ? 'noopener noreferrer' : undefined}
                                    target={isExternal ? '_blank' : undefined}>
                                    {ctaLabel}

                                    <span
                                        aria-hidden={true}
                                        className='ml-5'>
                                        <IconArrowRight
                                            height={20}
                                            width={20} />
                                    </span>
                                </a>
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TextColumns;
